import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { SiteI18nProvider } from "./site/SiteI18n";
import { SiteLayout } from "./site/SiteLayout";
import SiteHome from "./site/pages/SiteHome";
import SitePlatforma from "./site/pages/SitePlatforma";
import SiteSolutii from "./site/pages/SiteSolutii";
import SiteIndustrii from "./site/pages/SiteIndustrii";
import SiteDespre from "./site/pages/SiteDespre";
import SiteContact from "./site/pages/SiteContact";

const queryClient = new QueryClient();

const SiteRoutes = () => (
  <SiteLayout>
    <Routes>
      <Route path="/site" element={<SiteHome />} />
      <Route path="/site/platforma" element={<SitePlatforma />} />
      <Route path="/site/solutii" element={<SiteSolutii />} />
      <Route path="/site/industrii" element={<SiteIndustrii />} />
      <Route path="/site/despre" element={<SiteDespre />} />
      <Route path="/site/contact" element={<SiteContact />} />
      <Route path="/" element={<Navigate to="/site" replace />} />
      <Route path="*" element={<Navigate to="/site" replace />} />
    </Routes>
  </SiteLayout>
);

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider>
      <SiteI18nProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <SiteRoutes />
          </BrowserRouter>
        </TooltipProvider>
      </SiteI18nProvider>
    </ThemeProvider>
  </QueryClientProvider>
);

export default App;
